import { ChangeDetectorRef, Component, OnInit, ViewChild, EventEmitter, Output } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UserService } from '../../../services/userService/user.service';
import { environment } from '../../../../environments/environment';
import { MatPaginator } from '@angular/material/paginator';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { MatTableDataSource } from '@angular/material/table';
import { Sort } from '@angular/material/sort';

@Component({
  selector: 'app-projectdetails',
  templateUrl: './projectdetails.component.html',
  styleUrls: ['./projectdetails.component.css']
})

export class ProjectdetailsComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @Output() clearEvent = new EventEmitter<void>();
  displayedColumns: string[] = ['InquiryName', 'CustomerName', 'Stage', 'QuotedDate', 'QuotedValue', 'ReportedValue', 'BussinessVerticals', 'QuotationEngineer', 'SalesEngineer', 'ExpOrderDate'];
  sortData: any = { "column": "CompanyName", "direction": "asc" };
  dtOptions: any = {};
  showinquiry: any = [];
  currentPage: any = 0;
  pageSize: any = 10;
  totalSize: any;
  dataSource: any;
  registerForm: FormGroup;
  submitted = false;
  id: any;
  userid: any;
  downloadurl: string;
  url: any = '';
  permission: any;
  ProjectData: any;
  isCollapsed: boolean = false;
  ProjectId: string;
  showcompany: any;
  projectshow: string[];
  activityhistory: any;
  showMore: any;
  NextPageNo: any;
  loader: boolean = false;
  default: string;
  getactivityArr: any = [];
  comdata: any;
  TotalRecord: any;
  searchword: any;
  selectedInquiry: any = '';
  selectedCustomerId: any = '';
  selectedStageId: any = '';
  selectedQuotationErId: any = '';
  selectedBusinessNameId: any = '';
  selectedSalesErId: any = '';
  selectedInquiryId: any = '';
  type: string;
  namesort: string;
  downicon: boolean;
  upicon: boolean;
  columnsort: string;
  userRId: any;

  constructor(
    private UserService: UserService,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private changeDetectorRefs: ChangeDetectorRef,
    private router: Router
  ) { }

  ngOnInit(): void {
    let decid = this.route.snapshot.params['id'];
    decid = decid.toString().replace('Ar1t', '=').replace('FGH', '/').replace('THD', '+');
    this.id = this.UserService.decryptData(decid);
    let permi = JSON.parse(localStorage.getItem('Permission'));
    this.permission = this.UserService.decryptData(permi);
    let userrId = localStorage.getItem('roleId');
    this.userRId = this.UserService.decryptData(userrId);
    if (this.permission.Project_View != 1 && this.userRId != 1) {
      this.toastr.error('You do not have permission');
      this.router.navigate(['/profile']);
    }

    localStorage.setItem("editcid", decid);
    this.downloadurl = environment.app_downpath;
    this.url = environment.app_path;
    this.default = environment.showmore;
    this.registerForm = this.formBuilder.group({
      SearchWord: [''],
      ProjectId: [''],
      ProjectName: ['', Validators.required],
      QuotationEngineer: ['', Validators.required],
      SalesEngineer: ['', Validators.required],
      ProjectSource: ['', Validators.required],
      Territory: ['', Validators.required],
      ProjectStatus: [''],
      ClosedDate: [''],
      CreatedDate: [''],
      CreatedBy: this.userid,
    })

    let data = {
      "ProjectId": this.id,
      "SearchWord": "",
      "Sort": "",
      "SortWise": "",
      "ItemPerPages": this.pageSize,
      "PageNo": this.currentPage + 1,
    }
    this.spinner.show();
    this.UserService.GetInquiryListByProjectId(data).subscribe(
      (response: any) => {
        if (response['result'] == 'success') {
          this.spinner.hide();
          this.currentPage = 0;
          this.showinquiry = response['ContactList'];
          this.dataSource = new MatTableDataSource<any>(response['ContactList']);
          this.dataSource.paginator = this.paginator;
          this.TotalRecord = response['TotalRecord'];
          this.totalSize = response['TotalRecord'];
          this.iterator();
        }
      });

    let data1 = {
      "ProjectId": this.id
    }
    this.UserService.EditProject(data1).subscribe(res => {
      this.comdata = res['Data'];
      if (res['result'] == 'success') {
        this.ProjectId = res['Data']['ProjectNumber'];
        this.registerForm.patchValue({
          ProjectId: res['Data']['ProjectNumber'],
          ProjectName: res['Data']['ProjectName'],
          ProjectSource: res['Data']['ProjectSourceName'],
          Territory: res['Data']['TerritoryName'],
          QuotationEngineer: res['Data']['QuotationEngineerUser'],
          SalesEngineer: res['Data']['SalesEngineerUser'],
          ProjectStatus: res['Data']['ProjectStatusName'],
          ClosedDate: res['Data']['CloseDate'],
          CreatedDate: res['Data']['CreatedDate'],
          CreatedBy: res['Data']['UserName'],
        })
      }
    })
    this.isCollapsed = false;
    let historydata = {
      "ProjectId": this.id,
      "PageNo": this.currentPage + 1
    }

    this.UserService.GetProjectActivityHistory(historydata).subscribe(res => {
      if (res['result'] == 'success') {
        this.activityhistory = res['ContactList'];
        this.showMore = res['NextPage'];
        this.NextPageNo = res['NextPageNo'];
      }
    })

  }

  openClosefun() {
    this.isCollapsed = !this.isCollapsed
  }

  clearUserData() {
    const previousValue = this.searchword;
    this.searchword = '';
    if (previousValue && previousValue.length > 0 && previousValue !== this.searchword) {
      this.clearEvent.emit();
    }
  }

  showMoreactivity() {
    let data = {
      "PageNo": this.NextPageNo,
      "ProjectId": this.id
    }
    this.loader = true;
    this.UserService.GetProjectActivityHistory(data).subscribe(res => {
      this.spinner.show();
      if (res['result'] == 'success') {
        this.spinner.hide();
        this.loader = false;
        res['ContactList'].forEach(element => {
          this.activityhistory.push(element);
        });
        this.showMore = res['NextPage'];
      } else if (res['result'] == 'Failed') {
        this.toastr.error(res['Msg']);
        this.spinner.hide();
      } else {
        this.toastr.error(res['Message']);
        this.spinner.hide();
      }
    });
  }

  public handlePage(e: any) {
    this.spinner.show();
    this.currentPage = e.pageIndex;
    this.pageSize = e.pageSize;
    this.iterator();
    let data = {
      "SearchWord": this.searchword,
      "ProjectId": this.id,
      "Sort": "",
      "SortWise": "",
      "ItemPerPages": this.pageSize,
      "PageNo": this.currentPage + 1,
    }
    this.UserService.GetInquiryListByProjectId(data).subscribe((res) => {
      if (res['result'] == "success") {
        this.TotalRecord = res['TotalRecord'];
        this.totalSize = this.TotalRecord;
        this.spinner.hide();
        this.dataSource = new MatTableDataSource<any>(res['ContactList']);
      }
    })
  }

  private iterator() {
    const end = (this.currentPage + 1) * this.pageSize;
    const start = this.currentPage * this.pageSize;
    const part = this.showinquiry.slice(start, end);
    this.dataSource = part;
  }

  view(eid) {
    let encryptid = this.UserService.encryptData(eid);
    encryptid = encryptid.toString().replace('=', 'Ar1t').replace('/', 'FGH').replace('+', 'THD');
    this.router.navigate(['/inquiry/detailinquiry', encryptid]);
  }

  applyFilter() {
    this.spinner.show();
    let data = {
      "SearchWord": this.searchword,
      "ProjectId": this.id,
      "Sort": "",
      "SortWise": "",
      "ItemPerPages": this.pageSize,
      "PageNo": this.currentPage + 1,
    }
    this.UserService.GetInquiryListByProjectId(data).subscribe((res) => {
      if (res['result'] == "success") {
        this.TotalRecord = res['TotalRecord'];
        this.totalSize = this.TotalRecord;
        this.spinner.hide();
        this.dataSource = new MatTableDataSource<any>(res['ContactList']);
      }
    })
  }

  onSortData(sort: Sort) {
    this.spinner.show();
    this.changeDetectorRefs.detectChanges();
    this.sortData = [];
    this.sortData = { "column": sort.active, "direction": sort.direction };
    this.type = sort.direction;
    this.namesort = sort.active;
    if (sort.direction == "asc") {
      this.upicon = true;
      this.downicon = false;
    }
    else {
      this.upicon = false;
      this.downicon = true;
    }
    this.columnsort = sort.active;

    let data = {
      "SearchWord": this.searchword,
      "ProjectId": this.id,
      "ItemPerPages": this.pageSize,
      "PageNo": this.currentPage + 1,
      "Sort": sort.active,
      "SortWise": sort.direction,
    }
    this.UserService.GetInquiryListByProjectId(data).subscribe((res) => {
      if (res['result'] == "success") {
        this.TotalRecord = res['TotalRecord'];
        this.totalSize = this.TotalRecord;
        this.spinner.hide();
        this.dataSource = new MatTableDataSource<any>(res['ContactList']);
      }
    })
  }

}
